import { featuresData } from '@/mocks/homepage';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            为什么800万漫迷选择番茄漫画？五大核心优势告诉你答案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-6 text-center group hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-2xl bg-accent-100 flex items-center justify-center text-2xl text-accent-600">
                <i className={feature.icon}></i>
              </div>
              <h3 className="font-medium text-sm md:text-base text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}